import BenchedLogo from './benched-logo'

export const Footer = () => (
  <footer className='my-12 flex flex-col items-center gap-4 text-sm leading-relaxed text-foreground-lighter'>
    <div className='flex w-full max-w-xs items-center gap-4'>
      <span className='h-px grow bg-border' />
      <BenchedLogo size={48} />
      <span className='h-px grow bg-border' />
    </div>
    <p className='tracking-widest text-foreground-lighter/20'>&mdash; <span className='text-foreground-lighter'>BENCHED DOT AI</span> &mdash;</p>
    <p className='tracking-widest text-xs'><span className='tracking-widest text-foreground-lighter/50'>&copy;</span> 1985-{new Date().getFullYear()}</p>
  </footer>
)

export default Footer
